import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import founder from "../../assets/FounderImage/satyendra1.jpg";
const About = () => {
  useEffect(() => {
    document.title = "CodeQueue - About";
    window.scrollTo({ top: "0", behavior: "smooth" });
  }, []);

  return (
    <div className="bg-black text-white min-h-screen">
      {/* First Section */}
      <div className="mb-2 min-h-[550px]  shadow-lg bg-gradient-to-r from-black via-gray-900 to-black hover:shadow-2xl transition-all duration-300">
        <div className="mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-center">
            {/* Left Column */}
            <div className="flex flex-col justify-center px-5 sm:px-10">
              <h2 className="text-xl lg:text-5xl font-bold mb-5 mt-24 sm:mt-10">
                A Platform for the Next Generation of Learners!
              </h2>
              <NavLink
                to={"/mentors-list"}
                className="primary-btn bg-transparent border-2 text-white font-bold py-2 px-4 w-48 border-white hover:bg-white hover:text-black transition-all duration-300 mb-8"
              >
                Start Booking
              </NavLink>
            </div>

            {/* Right Column */}
            <div className="flex text-right items-center">
              <img
                src="https://www.notta.ai/pictures/virtual-one-on-one-meeting.png"
                alt="platform"
                className="lg:w-full  lg:h-[600px] sm:w-full sm:h-auto object-cover mr-1"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Second Section */}
      <div className=" min-h-[500px]  bg-white shadow-lg hover:shadow-2xl transition-all duration-300 p-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center py-4">
          {/* Left Column */}
          <div className="flex justify-center items-center  ml-5">
            <img
              src="https://img.freepik.com/free-photo/man-searching-with-magnifying-glass_1048-2931.jpg"
              alt="CodeQueue"
              className="lg:w-[400px] lg:h-auto sm:w-full sm:h-auto object-cover rounded md:h-auto md:w-[400px]"
            />
          </div>
          {/* Right Column */}
          <div className="px-4">
            <h3 className="text-2xl font-bold mb-3 text-black">
              What is CodeQueue?
            </h3>
            <p className="mb-2 text-black text-justify leading-relaxed">
              At CodeQueue, we believe in empowering individuals to reach their
              full potential by connecting them with experienced mentors who
              provide personalized career guidance. Whether you're a student
              stepping into the professional world or a working professional
              seeking growth, CodeQueue is here to support you on your journey.
              <p className="mt-3 text-justify leading-relaxed">
                Our vision is to create a platform where everyone has access to
                mentorship and tools to build a successful career.
              </p>
            </p>

            <h4 className="text-xl font-semibold text-black mt-4 text-left">
              Why Choose CodeQueue?
            </h4>
            <p className="text-black mt-2 text-justify leading-relaxed">
              We prioritize personalization and quality. Our platform is built
              for learners, by experts, ensuring that every session adds value
              to your career journey.
            </p>
          </div>
        </div>
      </div>

      {/* Third Section */}
      <div className="mt-4 p-2 min-h-[500px] bg-gradient-to-r from-black via-navy-900 to-gray-900 ">
        <div className="container mx-auto p-2">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-center p-1">
            {/* Left Column */}
            <div className="flex flex-col justify-center bg-gradient-to-r from-black via-gray-900 to-black p-2 min-h-[500px] ">
              <h2 className="text-3xl font-bold text-white mb-5">
                Meet the Founder - Satyendra Kumar
              </h2>
              <p className="text-white mb-4">
                Satyendra Kumar is a skilled software developer and mentor with
                strong expertise in building scalable, user-centric web
                applications. Currently working at Capgemini in the Application
                Management Support (AMS) division, he brings over a year of
                hands-on experience in maintaining, enhancing, and supporting
                enterprise-level Java full-stack applications. His work involves
                resolving complex issues, improving system performance, and
                ensuring high application availability — all while staying
                aligned with modern development practices and technologies
              </p>
              <p className="text-white mb-4">
                {" "}
                He is also the creator of CodeQueue , an innovative platform
                designed to connect to students and professional with expert
                mentors for personalized career guidance .Through CodeQueue, he
                aims to bridge the gap aspiring individuals and the support they
                need to excel in their careers, offering services like interview
                preparations, resume reviews and one-on-one mentorship.
              </p>
              {/* <p className="text-white mb-4">
                Proficient in Java, React, Node.js, MongoDB and the MERN Stack,
                he combines technical expertise with a passion for mentoring
                others. His vision is to make quality mentorship accessible to
                everyone, empowering individuals to confidently navigate their
                professional Journeys and achieve their goals
              </p> */}
            </div>

            {/* Right Column */}
            <div className="flex justify-center items-center">
              <img
                src={founder}
                alt="founder"
                className="w-[100%] sm:w-[350px] h-auto object-cover rounded-md border-white border-2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
